import React from 'react'
import { observer } from 'mobx-react'
import PrefixContext from '../contexts/PrefixContext'
import useName from '../hooks/use-name'
import useIndex from '../hooks/use-index'

function PrefixIndex (props) {
  const name = useName()
  const index = useIndex()

  if (index === null) {
    throw new Error('Attempted to prefix index, but NULL was provided.')
  }

  const prefix = [name, index].join('.')

  return (
    <PrefixContext.Provider value={prefix}>
      {props.children}
    </PrefixContext.Provider>
  )
}

export default observer(PrefixIndex)
